module.exports = __webpack_public_path__ + "static/media/logo_android.ef978405.svg";